/* eslint-disable */
import Vue from 'vue';
import axios from 'axios';

const USER_REQUEST = 'USER_REQUEST';
const USER_SUCCESS = 'USER_SUCCESS';
const USER_ERROR = 'USER_ERROR';
const USER_LOGOUT = 'USER_LOGOUT';

const userModule = {
  state: {
    user: {
      status: '',
      profile: {},
    },
  },
  getters: {
    isProfileLoaded: state => !!state.user.profile.name,
    getProfile: state => state.user.profile,
  },
  mutations: {
    [USER_REQUEST]: state => {
      state.user.status = 'loading';
    },
    [USER_SUCCESS]: (state, resp) => {
      state.user.status = 'success';
      state.user.profile = resp;
      // Vue.set(state.user, 'profile', resp); // idk if we need this
    },
    [USER_ERROR]: state => {
      state.user.status = 'error';
    },
    [USER_LOGOUT]: state => {
      state.user.status = '';
      state.user.profile = {};
    },
  },
  actions: {
    [USER_REQUEST]: ({ commit, dispatch }) => {
      commit(USER_REQUEST);
      axios({ url: 'user/me' })
        .then(resp => {
          commit(USER_SUCCESS, resp);
        })
        .catch(resp => {
          commit(USER_SUCCESS, resp);
          // commit(USER_ERROR);
          // if resp is unauthorized, logout, to
          // dispatch('USER_LOGOUT');
          // dispatch('AUTH_LOGOUT');
        });
    },
    [USER_LOGOUT]: ({ commit, dispatch }) =>
      new Promise((resolve, reject) => {
        commit(USER_LOGOUT);
        resolve();
      }),
  },
};

export default userModule;
